//jqueryFree
import { disableVanillaSubmit } from '../../../layout-common/js/parts/utils';

export default function () {
	const replyPopupEl = document.getElementById('reply-popup');
	if (!replyPopupEl) {
		return;
	}

	//Otevře odkaz "Detail" na další offer nabízený v popupu do nové karty prohlížeče
	let allowClickableLinks = document.querySelectorAll('.allowClickableLink');
	allowClickableLinks.forEach(function (link) {
		link.addEventListener('click', function (e) {
			e.preventDefault();
			let url = link.getAttribute('href');
			window.open(url, '_blank');
		});
	});

	//Pokud uživatel v popupu odškrtne všechny další nabízené offery, zablokuje se odesílací tlačítko
	function areAllCheckboxesUnchecked(container) {
		const checkboxes = container.querySelectorAll('input[type="checkbox"]');
		return Array.from(checkboxes).every(function (checkbox) {
			return !checkbox.checked;
		});
	}

	const offersCheckBoxCont = replyPopupEl.querySelector('.offersCont');
	const blueButton = replyPopupEl.querySelector('.butonsCont .butonsContIn .blueButton');

	const checkboxes = offersCheckBoxCont.querySelectorAll('input[type="checkbox"]');
	checkboxes.forEach(function ({ addEventListener }) {
		addEventListener('change', function () {
			let allUnchecked = areAllCheckboxesUnchecked(offersCheckBoxCont);
			if (allUnchecked) {
				blueButton.classList.add('greyButton');
				blueButton.disabled = true;
			} else {
				blueButton.classList.remove('greyButton');
				blueButton.disabled = false;
			}
		});
	});

	//Pokud si uživatel v popupu vybere další nabízené offery, po kliku na potvrzovací tlačítko se vygeneruje trackovací dataLayer a volba se odešle
	const blueButtonReplyPopUp = document.querySelector('.butonsContIn .blueButton.buttonReplyPopUp');

	blueButtonReplyPopUp.addEventListener('click', function (e) {
		e.preventDefault();
		let quantityReply = 0;
		let sendMorePopUpEvent = { event: 'send_more_pop_up' };

		const form = this.closest('form');
		const checkboxes = form.querySelectorAll('.offersCont input[type="checkbox"]');

		checkboxes.forEach(function (checkbox, i) {
			if (checkbox.checked) {
				quantityReply++;
				sendMorePopUpEvent['marked_position_' + i] = true;
			} else {
				sendMorePopUpEvent['marked_position_' + i] = false;
			}
		});

		if (quantityReply === 0) {
			alert('Vyberte prosím nabídku.');
			return false;
		}
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push(sendMorePopUpEvent);
		window.dataLayer.push({ event: 'pop_up_reply_Q', quantity: quantityReply });

		disableVanillaSubmit(blueButtonReplyPopUp);
		form.submit();
	});
}
